// FTEDN Creator — Main Layout
import { useEffect } from 'react';
import { PhoneCollectionPrompt } from '../auth/PhoneCollectionPrompt';
import { Sidebar } from './Sidebar';
import { BottomTabBar } from './BottomTabBar';
import { useUserStore } from '../../stores/user.store';
import './MainLayout.css';

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  const { profile, loading, fetchProfile } = useUserStore();

  useEffect(() => {
    if (!profile && !loading) {
      fetchProfile();
    }
  }, [fetchProfile, loading, profile]);

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="app-main">
        <PhoneCollectionPrompt />
        {children}
      </main>
      <BottomTabBar />
    </div>
  );
}
